import React, { useRef, useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend, Title } from "chart.js";
import trasportApi from "../../api/trasportApi";
import { useNavigate } from "react-router-dom";
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels);

const DonutChart = ({ filterDateData }) => {
  const navigate = useNavigate();
  const chartRef = useRef(null);
  const [refreshPage, setRefreshPage] = useState(false);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Branch Wise Challan",
        data: [],
        backgroundColor: [],
        borderColor: [],
        borderWidth: 1,
        hoverOffset: 4,
      },
    ],
  });

  // Fixed color assignments for each branch name (you can adjust colors here)
  const colors = [
    "#DB7093", // Pale Violet Red
    "#66CDAA", // Medium Aquamarine
    "#20B2AA", // Light Sea Green
    "#6495ED", // Cornflower Blue
    "#E9967A", // Dark Salmon
    "#F4A460", // Sandy Brown
    "#FFD700", // Gold
    "#3CB371", // Medium Sea Green
    "#8A2BE2", // Blue Violet
    "#FF6347", // Tomato
  ];

  useEffect(() => {
    fetchLeadsData(filterDateData);
    setRefreshPage(true);
  }, [filterDateData]);

  // Function to assign colors dynamically based on the number of branch labels
  const assignDynamicColors = (labels) => {
    const backgroundColor = labels.map((_, index) => colors[index % colors.length]);
    const borderColor = backgroundColor.map((color) => color.replace("0.2", "1"));
    return { backgroundColor, borderColor };
  };

  async function fetchLeadsData(filterDateData) {
    try {
      if (filterDateData && filterDateData.month && filterDateData.financial_year_id) {
        const fetchLeads = await trasportApi.fetchChallanCurrentMonth(filterDateData);

        if (fetchLeads.length > 0) {
          const stageCount = fetchLeads.reduce((acc, lead) => {
            acc[lead.branch_name] = (acc[lead.branch_name] || 0) + 1;
            return acc;
          }, {});

          const labels = Object.keys(stageCount); // Branch names from DB
          const data = Object.values(stageCount); // Counts of branches
          const { backgroundColor, borderColor } = assignDynamicColors(labels);

          setChartData({
            labels: labels,
            datasets: [
              {
                ...chartData.datasets[0],
                data: data,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
              },
            ],
          });
        }
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  }

  const options = {
    animation: {
      animateScale: true,
      animateRotate: true,
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
      },
      datalabels: {
        color: '#fff',
        formatter: (value, context) => {
          return value;
        },
      },
    },
    layout: {
      padding: {
        bottom: 10,
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        const index = elements[0].index;
        const branchName = chartData.labels[index];
        onBranchClick(branchName);
      }
    },
  };

  const onBranchClick = (branchName) => {
    navigate("/leads", { state: { branchName: branchName } });
  };

  return (
    <div
      style={{
        width: "600px",
        height: "400px",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      {refreshPage && (
        <div style={{ width: "100%", height: "100%" }}>
          <Doughnut ref={chartRef} data={chartData} options={options} />
        </div>
      )}
    </div>
  );
};

export default DonutChart;